const pagesPersonAddPersonCertificationEn = {
  add: {
    form: {
      completed: {
        completedBy: 'Completed by:',
        continueAdding: 'Continue adding another certification holder',
        goToCertificationHolderData: 'Go to certification holder data',
        goToList: 'Go to list',
        message: 'Certification Holder added.',
        result: 'Result'
      },
      fields: {
        personBaseCertificationBasicInfo: {
          acquisitionType: {
            label: 'Acquisition Type',
            placeholder: 'Enter acquisition type'
          },
          baseCertification: {
            label: 'Base Certification'
          },
          certificationHolder: {
            label: 'Certification Holder'
          },
          certificationNumber: {
            label: 'Certification Number',
            placeholder: 'Enter certification number'
          },
          firstAcquiredDate: {
            label: 'First Acquired Date',
            placeholder: 'Select first acquired date'
          },
          lastRenewalDate: {
            label: 'Last Renewal Date',
            placeholder: 'Select last renewal date'
          },
          renewalDeadline: {
            label: 'Renewal Deadline',
            placeholder: 'Select renewal deadline'
          },
          validTo: {
            label: 'Valid To',
            placeholder: 'Select valid to date'
          }
        },
        personBaseCertificationEvidence: {
          certificateFilePath: {
            label: 'Certificate File Path',
            placeholder: 'Enter certificate file path'
          },
          lastVerifiedDate: {
            label: 'Last Verified Date',
            placeholder: 'Select last verified date'
          },
          originalVerificationDate: {
            label: 'Original Verification Date',
            placeholder: 'Select original verification date'
          },
          originalVerifier: {
            label: 'Original Verifier',
            placeholder: 'Enter original verifier'
          },
          verificationMethod: {
            label: 'Verification Method',
            placeholder: 'Enter verification method'
          }
        },
        personBaseCertificationIssueInfo: {
          issueDate: {
            label: 'Issue Date',
            placeholder: 'Select issue date'
          },
          issuePlace: {
            label: 'Issue Place',
            placeholder: 'Enter issue place'
          },
          issuingOrganizationId: {
            label: 'Issuing Organization',
            placeholder: 'Enter issuing organization'
          }
        },
        personBaseCertificationOperations: {
          criticalCertificationFlag: {
            checkboxLabel: 'This is a critical certification',
            label: 'Critical Certification Flag'
          },
          managementType: {
            label: 'Management Type',
            placeholder: 'Enter management type'
          },
          remarks: {
            label: 'Remarks',
            placeholder: 'Enter remarks'
          }
        },
        personBaseCertificationStatus: {
          certificationStatus: {
            label: 'Certification Status',
            placeholder: 'Select certification status'
          },
          certificationStatusChangeDate: {
            label: 'Certification Status Change Date',
            placeholder: 'Select certification status change date'
          },
          certificationStatusReason: {
            label: 'Certification Status Reason',
            placeholder: 'Enter certification status reason'
          }
        },
        personHandlingCertificationBasicInfo: {
          certificationHolder: {
            label: 'Certification Holder'
          },
          certificationNumber: {
            label: 'Certification Number',
            placeholder: 'Enter certification number'
          },
          handlingCertification: {
            label: 'Handling Certification'
          },
          handlingEndDate: {
            label: 'Handling End Date',
            placeholder: 'Select handling end date'
          },
          handlingStartDate: {
            label: 'Handling Start Date',
            placeholder: 'Select handling start date'
          },
          lastRenewalDate: {
            label: 'Last Renewal Date',
            placeholder: 'Select last renewal date'
          },
          personBaseCertificationRecordIds: {
            add: 'Add Related Base Certification Record',
            label: 'Base Certification Records'
          },
          personSpecialtyCertificationRecordIds: {
            add: 'Add Related Specialty Certification Record',
            label: 'Specialty Certification Records'
          },
          renewalDeadline: {
            label: 'Renewal Deadline',
            placeholder: 'Select renewal deadline'
          },
          validTo: {
            label: 'Valid To',
            placeholder: 'Select valid to date'
          }
        },
        personHandlingCertificationCondition: {
          channel: {
            label: 'Channel',
            placeholder: 'Enter channel'
          },
          examId: {
            label: 'Exam ID',
            placeholder: 'Enter exam ID'
          },
          handlingRestrictionCondition: {
            label: 'Handling Restriction Condition',
            placeholder: 'Enter handling restriction condition'
          },
          place: {
            label: 'Place',
            placeholder: 'Enter place'
          },
          trainingId: {
            label: 'Training ID',
            placeholder: 'Enter training ID'
          }
        },
        personHandlingCertificationEvidence: {
          certificateFilePath: {
            label: 'Certificate File Path',
            placeholder: 'Enter certificate file path'
          },
          lastVerifiedDate: {
            label: 'Last Verified Date',
            placeholder: 'Select last verified date'
          }
        },
        personHandlingCertificationIssueApproval: {
          approvedDate: {
            label: 'Approved Date',
            placeholder: 'Select approved date'
          },
          internalApprover: {
            label: 'Internal Approver',
            placeholder: 'Enter internal approver'
          },
          issuingOrganizationId: {
            label: 'Issuing Organization',
            placeholder: 'Enter issuing organization'
          }
        },
        personHandlingCertificationOperations: {
          priority: {
            label: 'Priority',
            placeholder: 'Enter priority'
          },
          remarks: {
            label: 'Remarks',
            placeholder: 'Enter remarks'
          }
        },
        personHandlingCertificationStatus: {
          certificationStatus: {
            label: 'Certification Status',
            placeholder: 'Select certification status'
          },
          certificationStatusChangeDate: {
            label: 'Certification Status Change Date',
            placeholder: 'Select certification status change date'
          },
          certificationStatusReason: {
            label: 'Certification Status Reason',
            placeholder: 'Enter certification status reason'
          }
        },
        personSpecialtyCertificationBasicInfo: {
          acquisitionType: {
            label: 'Acquisition Type',
            placeholder: 'Enter acquisition type'
          },
          baseCertificationId: {
            label: 'Base Certification ID',
            placeholder: 'Enter base certification ID'
          },
          certificationHolder: {
            label: 'Certification Holder'
          },
          certificationNumber: {
            label: 'Certification Number',
            placeholder: 'Enter certification number'
          },
          firstAcquiredDate: {
            label: 'First Acquired Date',
            placeholder: 'Select first acquired date'
          },
          lastRenewalDate: {
            label: 'Last Renewal Date',
            placeholder: 'Select last renewal date'
          },
          personBaseCertificationRecordIds: {
            add: 'Add Related Base Certification Record',
            label: 'Base Certification Records'
          },
          renewalDeadline: {
            label: 'Renewal Deadline',
            placeholder: 'Select renewal deadline'
          },
          specialtyCertification: {
            label: 'Specialty Certification'
          },
          validTo: {
            label: 'Valid To',
            placeholder: 'Select valid to date'
          }
        },
        personSpecialtyCertificationCondition: {
          caseCountAtAcquisition: {
            label: 'Case Count at Acquisition',
            placeholder: 'Enter case count at acquisition'
          },
          experienceYearsAtAcquisition: {
            label: 'Experience Years at Acquisition',
            placeholder: 'Enter experience years at acquisition'
          }
        },
        personSpecialtyCertificationEvidence: {
          certificateFilePath: {
            label: 'Certificate File Path',
            placeholder: 'Enter certificate file path'
          },
          lastVerifiedDate: {
            label: 'Last Verified Date',
            placeholder: 'Select last verified date'
          },
          originalVerifiedDate: {
            label: 'Original Verified Date',
            placeholder: 'Select original verified date'
          },
          originalVerifier: {
            label: 'Original Verifier',
            placeholder: 'Enter original verifier'
          }
        },
        personSpecialtyCertificationOperations: {
          primarySpecialtyFlag: {
            checkboxLabel: 'This is a primary specialty',
            label: 'Primary Specialty Flag'
          },
          remarks: {
            label: 'Remarks',
            placeholder: 'Enter remarks'
          }
        },
        personSpecialtyCertificationStatus: {
          certificationStatus: {
            label: 'Certification Status',
            placeholder: 'Select certification status'
          },
          certificationStatusChangeDate: {
            label: 'Certification Status Change Date',
            placeholder: 'Select certification status change date'
          },
          certificationStatusReason: {
            label: 'Certification Status Reason',
            placeholder: 'Enter certification status reason'
          }
        }
      },
      navigation: {
        steps: {
          common: {
            submitButtonLabel: 'Add Certification Holder'
          },
          personBaseCertificationBasicInfo: {
            title: 'Basic Info'
          },
          personBaseCertificationEvidence: {
            title: 'Evidence/Verification'
          },
          personBaseCertificationIssueInfo: {
            title: 'Issue Info'
          },
          personBaseCertificationOperations: {
            title: 'Operations Support'
          },
          personBaseCertificationStatus: {
            title: 'Certification Status'
          },
          personHandlingCertificationBasicInfo: {
            title: 'Basic Info'
          },
          personHandlingCertificationCondition: {
            title: 'Condition Information'
          },
          personHandlingCertificationEvidence: {
            title: 'Evidence/Verification'
          },
          personHandlingCertificationIssueApproval: {
            title: 'Issue/Approval Information'
          },
          personHandlingCertificationOperations: {
            title: 'Operations Support'
          },
          personHandlingCertificationStatus: {
            title: 'Certification Status'
          },
          personSpecialtyCertificationBasicInfo: {
            title: 'Basic Info'
          },
          personSpecialtyCertificationCondition: {
            title: 'Condition Information'
          },
          personSpecialtyCertificationEvidence: {
            title: 'Evidence/Verification'
          },
          personSpecialtyCertificationOperations: {
            title: 'Operations Support'
          },
          personSpecialtyCertificationStatus: {
            title: 'Certification Status'
          }
        },
        title: 'Add certification'
      },
      progressbar: {
        filled: 'filled',
        left: '{{value}} left',
        modeSetting: 'Mode Settings',
        mustItem: 'Must Item',
        mustItemOnly: 'Must item only',
        total: 'Total'
      }
    },
    intro: {
      body: {
        fillOutDetails: 'Fill out the details',
        selectCertification: 'Select the certification:',
        selectPerson: 'Select the person:',
        selectPersonAndCertification: 'Select the person and certification: ',
        selectPersonPlaceholder: 'Select the person'
      },
      header: {
        headerTitle: 'Add Certification holder Data to your Registry'
      },
      options: {
        addCertification: 'Add certification data',
        description: 'Or you might want to...'
      }
    }
  },
  certificationKind: {
    base: 'Base certification',
    handling: 'Handling certification',
    specialty: 'Specialty certification'
  },
  detail: {
    body: {
      errors: {
        certificationIdLabel: 'Certification ID: {{id}}',
        certificationNotFound: 'Certification details not found',
        dataLoadFailed: 'Failed to load data',
        unknownError: 'An unknown error occurred'
      },
      noDataMessage: 'No data available in this section.'
    },
    tabs: {
      detail: 'Detail',
      handlingCertifications: 'Handling certifications',
      specialtyCertifications: 'Specialty certifications'
    }
  },
  handling: {
    detail: {
      body: {
        errors: {
          dataLoadFailed: 'Failed to load data',
          handlingCertificationIdLabel: 'Handling Certification ID: {{id}}',
          handlingCertificationNotFound: 'Handling certification details not found',
          unknownError: 'An unknown error occurred'
        },
        noDataMessage: 'No data available in this section.'
      },
      tabs: {
        detail: 'Detail'
      }
    },
    list: {
      addHandlingCertification: 'Add Handling Certification',
      filterPlaceholder: 'Search by handling certification name...',
      pageTitle: 'Handling Certifications',
      tabs: {
        archived: 'Archived',
        effective: 'Effective',
        notEffective: 'Not Effective'
      }
    }
  },
  list: {
    actions: {
      export: 'Export',
      share: 'Share'
    },
    addCertification: 'Add Certification',
    filterPlaceholder: 'Search by certification name...',
    pageTitle: 'Certifications',
    tabs: {
      all: 'All',
      national: 'National',
      private: 'Private',
      public: 'Public'
    }
  },
  specialty: {
    detail: {
      body: {
        errors: {
          dataLoadFailed: 'Failed to load data',
          specialtyCertificationIdLabel: 'Specialty Certification ID: {{id}}',
          specialtyCertificationNotFound: 'Specialty certification details not found',
          unknownError: 'An unknown error occurred'
        },
        noDataMessage: 'No data available in this section.'
      },
      tabs: {
        detail: 'Detail'
      }
    },
    list: {
      addSpecialtyCertification: 'Add Specialty Certification',
      filterPlaceholder: 'Search by specialty certification name...',
      pageTitle: 'Specialty Certifications',
      tabs: {
        archived: 'Archived',
        effective: 'Effective',
        notEffective: 'Not Effective'
      }
    }
  }
};
export default pagesPersonAddPersonCertificationEn;